<template>
  <div>
    <spinner :show="isLoading" />
    <div v-if="!isLoading">
      <div v-if="totalUsers === 0">
        <strong>This organization does not have any users. You can create users for an organization on the <router-link :to="adminHomeURL" class="clickable underline">admin dashboard</router-link>.</strong>
      </div>
      <div v-else>
        <div v-if="allowPagination" class="pagination">
          <b-pagination
            v-if="totalUsers > perPage"
            v-model="currentPage"
            :total-rows="totalUsers"
            :per-page="perPage"
            aria-controls="user-table"
          ></b-pagination>
        </div>

        <b-table
          id="user-table"
          :items="users"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
        >
          <template v-slot:cell(email)="data">
            <a :href="`mailto:${data.item.email}`" class="underline">
              {{ data.item.email }}
            </a>
          </template>
          <template v-slot:cell(phone_number)="data">
            <a
              v-if="data.item.phone_number"
              :href="`tel:${data.item.phone_number}`"
            >
              {{ phoneNum(data.item.phone_number) }}
            </a>
          </template>
          <template v-slot:cell(enabled)="data">
            <toggle-button
              :value="data.item.isEnabled"
              :sync="true"
              :color="{checked: '#008565', unchecked: '#989799', disabled: '#989799'}"
              :width="40"
              @change="toggleDisabled(data.item)"
            />
          </template>
          <template v-slot:cell(remove)="data">
            <button class="btn-nobackground" @click="onDeleteClick(data.item, $event)"><i class="zmdi zmdi-delete"></i></button>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '../Spinner';
import modalNames from '../../util/modalNames';
import routeNames from '../../util/routeNames';
import transformPhoneNum from '../../util/dataTransformation';

export default {
  name: 'UserTable',
  components: { Spinner },
  props: {
    limit: {
      type: Number,
      default: 10
    },
    allowPagination: {
      type: Boolean,
      default: true
    },
  },
   data() {
    return {
      adminHomeURL: routeNames.ADMIN.PATH,
      perPage: this.limit,
      currentPage: 1,
      fields: [
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'email',
          sortable: false
        },
        {
          key: 'role',
          sortable: true
        },
        {
          key: 'phone_number',
          label: 'Phone',
          sortable: false
        },
        {
          key: 'enabled',
          sortable: false,
           class: 'table-toggle'
        },
        {
          key: 'remove',
          sortable: false,
          class: 'table-remove-icon'
        }
      ],
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters.getIsUsersLoading;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    totalUsers() {
      return this.$store.getters.getUsers.length;
    },
  },
  mounted() {
    this.$store.dispatch('listUsers', this.$route.params.id);
  },
  methods: {
    toggleDisabled(item) {
      console.log('Item being toggled: ', item);
      const user = {
        ...item,
      };
      this.$store.dispatch('setUserToUpdate', user);
      this.$bvModal.show(modalNames.DISABLE_USER_CONFIRMATION_MODAL);
    },
    onInfoClick(item, event) {
      event.preventDefault();
      this.$store.dispatch('setUserToUpdate', item);
      this.$bvModal.show(modalNames.CREATE_USER_MODAL);
    },
    phoneNum(phoneNumStr) {
      return transformPhoneNum(phoneNumStr);
    },
    onDeleteClick(item, event) {
      event.preventDefault();
      console.log('deleting user');
      this.$store.dispatch('setUserToDelete', item);
      this.$bvModal.show(modalNames.DELETE_USER_CONFIRMATION_MODAL);
    },
  }
}
</script>
